module.exports = __webpack_public_path__ + "static/media/icon_evaluation_lose.d5646f95.svg";